import styles from "./JobSkeletonGrid.module.css";

interface SkeletonGridProps {
  rows?: number;
  columns?: number;
}

export const SkeletonGrid: React.FC<SkeletonGridProps> = ({
  rows = 2,
  columns = 2,
}) => (
  <div className={styles.skeletonContainer}>
    {Array.from({ length: columns }).map((_, col) => (
      <div key={col} className={styles.skeletonColumn}>
        {Array.from({ length: rows }).map((_, row) => (
          <div key={row} className={styles.skeletonRow}>
            <div className={`${styles.skeletonShort} ${styles.skeletonPulse}`} />
            <div className={`${styles.skeletonLong} ${styles.skeletonPulse}`} />
          </div>
        ))}
      </div>
    ))}
  </div>
);
